import { theme } from '../../../theme/theme';

const styles = {
  headingSmall: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 'bold',
    paddingBottom: '10px',
    '& span': {
      fontSize: '14px',
    },
  },
  sectionSpacing: {
    paddingBottom: '20px',
  },
  gridContainer: {
    padding: '20px 20px 0 20px',
    marginTop: '0',
    height: '100%',
  },
  divContainer: {
    display: 'flex',
    padding: '0 16px',
    alignItems: 'center',
    width: '100%',
  },
  buttonStyle: {
    width: '30%',
    height: '40px',
    position: 'relative',
    top: '5px',
  },
  cardBox: {
    boxSizing: 'content-box',
  },
  freezeDateTooltip: {
    fontSize: '18px',
  },
  freezeDateTooltipIcon: {
    position: 'absolute',
    bottom: '8px',
    right: '9px',
    marginBottom: '-4px',
    marginLeft: '10px',
  },
  minPurchaseTooltip: {
    marginLeft: '10px',
    marginBottom: '-4px',
  },
  datePickerPosition: {
    position: 'relative',
    top: '-7px',
  },
  formControl: {
    margin: '15px',
    minWidth: 120,
  },
  offerPreview: {
    padding: '15px 15px 70px 15px',
    height: '100%',
    position: 'relative',
  },
  headline: {
    padding: '15px',
    background: '#ffde00',
    fontSize: '18px',
    marginTop: '0',
  },
  disclaimerPreview: {
    paddingBottom: '20px',
    height: '250px',
    overflowY: 'scroll',
  },
  previewPane: {
    padding: '5px 15px',
    marginBottom: '10px',
    backgroundColor: '#f5f5f5',
  },
  offer: {
    height: '100%',
  },
  offerTitle: {
    background: '#dcdcdc',
    padding: '15px',
    margin: '1px 0px 0',
  },
  productList: {
    margin: 0,
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px',
    border: '1px solid #a4a4a4',
    borderRadius: '3px',
    '& li': {
      padding: '10px',
      marginRight: '5px',
      marginBottom: '5px',
      background: '#eaeaea',
    },
  },
  action: {
    justifyContent: 'space-between',
    marginTop: '30px',
    position: 'absolute',
    bottom: '0',
    left: 0,
    padding: '15px 10px',
    boxShadow: '0 0 5px rgba(0,0,0,0.25)',
    width: '100%',
    background: '#fff',
  },
  draftBtn: {
    marginLeft: '15px',
    background: '#e0e0e0',
  },
  stringDate: {
    '& span': {
      lineHeight: '1.7',
    },
  },
  breadcrumbHolder: {
    padding: '10px 0',
  },
  open: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.open,
    fontWeight: 600,
  },
  published: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.published,
    fontWeight: 600,
    color: theme.palette.primary.white,
    marginLeft: '8px',
  },
  draft: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.draft,
    fontWeight: 600,
    color: theme.palette.primary.white,
    marginLeft: '8px',
  },
  archived: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.archived,
    color: theme.palette.primary.white,
    fontWeight: 600,
  },
  frozen: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.frozen,
    color: theme.palette.primary.white,
    fontWeight: 600,
  },
  closed: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.closed,
    fontWeight: 600,
    marginLeft: '8px',
  },
  datePicker: {
    fontSize: '14px',
    border: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    paddingBottom: '5px',
    width: '100%',
    textAlign: 'left',
  },
  datePickerBox: {
    fontSize: '14px',
    border: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    paddingBottom: '5px',
    width: '100%',
    textAlign: 'center',
  },
  freezeDate: {},
  formError: {
    color: theme.palette.error.main,
    marginBottom: '5px',
  },
  fliptooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: '14px',
  },
  formGroup: {
    marginBottom: '1rem',
  },
  minPurchaseValue: {
    flex: 1,
  },
  disclaimerDateField: {
    marginBottom: '1rem',
    '& .react-datepicker-wrapper': {
      minWidth: '150px',
    },
  },
  notFoundTitle: {
    color: theme.palette.error.main,
    fontWeight: 'normal',
  },
  popper: {
    zIndex: 1,
  },
  headlinePreview: {
    '& span': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  productLabel: {
    textTransform: 'capitalize',
  },
  previewTextField: {
    opacity: 0.5,
    padding: '6px 0 7px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
  },
  previewDateField: {
    height: '48px',
    opacity: 0.5,
    padding: '19px 25px 0 10px',
    fontSize: '14px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
  },
  disableCard: {
    opacity: '0.5',
    pointerEvents: 'none',
  },
};

export default styles;
